import React from 'react';
import { Rate } from 'antd';
import './NoteRate.css';


const NoteRate = ({ rate, lastMessage }) => {
  const note = lastMessage?.messageUpdateStatut?.note;

  return (
    <div style={{display: 'flex', flexDirection: 'row', paddingTop: '10px', justifyContent: 'flex-end', alignItems: 'center'}}>

      <div style={{ display: 'flex', flexDirection: 'row', marginRight: '50px' }}>
        {rate && (
          <>
            <span
              style={{
                fontFamily: 'DM Sans',
                fontSize: '16px',
                fontWeight: 600,
                lineHeight: '24px',
                letterSpacing: '0em',
                textAlign: 'left',
                marginRight: '10px',
              }}
            >
              Note globale
            </span>{' '}
            <Rate
              allowHalf
              defaultValue={rate}
              disabled
              style={{
                fontSize: 20,
                color: '#FDB022'

              }}
            />
          </>
        )}
      </div>
      {note && (
        <div
          className="note-content"
          dangerouslySetInnerHTML={{ __html: note }}
        />
      )}
    </div>
  );
};

export default NoteRate;
